<div #header class="header-wrap" [class.hidden]="headerHidden">
  <rtr-header (logOut)="logOut()" />
  <rtr-breadcrumbs />
</div>

<div class="main-outlet" [class.has-breadcrumbs]="hasBreadcrumbs">
  @if (sidebarOpen) {
    <rtr-sidebar (logOut)="logOut()" />
  }
  <rtc-detached-router-outlet />
</div>
<rtr-footer />
<div class="footer-sticky">
  <ng-container [ngTemplateOutlet]="templateRef" />
</div>
